export default __webpack_public_path__ + "static/spark-27f21ca4cc0ad13627423faaa46f8168.svg";